/**
 * Renders a component for display.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function componentColumn({createElement, cachedColumn, rowData}) {
    let children;
    if (cachedColumn.props.component && cachedColumn.props.render) {
        throw new Error(`Cannot define a component and render function at the same time for ${cachedColumn.header}.`);
    }
    if (cachedColumn.props.component) {
        children = [
            createElement(
                cachedColumn.props.component,
                {
                    props: {
                        entry: rowData,
                        ...(cachedColumn.props.propsData || {}),
                    },
                },
            ),
        ];
    } else if (cachedColumn.props.render) {
        children = [cachedColumn.props.render.call(null, {createElement, fields: rowData.fields})];
    }
    return [
        'div',
        children,
    ];
}
